module.exports = __webpack_public_path__ + "static/Manufacturing-hero-1b106553bbca564968ecb816a9d9fe9d.png";